// extracted by mini-css-extract-plugin
export var ribbonContainer = "styles-module--ribbonContainer--pjquE";
export var ribbonImage = "styles-module--ribbonImage--7WPmU";
export var ribbon = "styles-module--ribbon--o2th7";
export var image = "styles-module--image--A8KKm";